var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContracts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30573_15491)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4186 15.625H26.5814C26.3324 14.9954 25.7182 14.55 25 14.55C24.2818 14.55 23.6676 14.9954 23.4186 15.625ZM21.9375 15.625C22.2271 14.1986 23.4882 13.125 25 13.125C26.5118 13.125 27.7729 14.1986 28.0625 15.625H32.8529C33.6936 15.625 34.375 16.2815 34.375 17.0912V35.4087C34.375 36.2185 33.6936 36.875 32.8529 36.875H17.1471C16.3064 36.875 15.625 36.2185 15.625 35.4087V17.0912C15.625 16.2815 16.3064 15.625 17.1471 15.625H21.9375ZM26.8178 21.6225L29.6259 24.4306L30.3291 23.7231C30.518 23.5364 30.6212 23.2859 30.6212 23.0178C30.6212 22.752 30.518 22.5014 30.3291 22.3125L28.9338 20.9173C28.747 20.7283 28.4965 20.625 28.2284 20.625C27.9625 20.625 27.7121 20.7283 27.5231 20.9173L26.8178 21.6225ZM19.4746 31.7761C19.5382 31.8398 19.6239 31.875 19.714 31.875C19.7448 31.875 19.7756 31.8706 19.8063 31.8618L22.9001 30.9807L20.2721 28.3527L19.3888 31.4421C19.3537 31.5607 19.3867 31.6882 19.4746 31.7761ZM20.6281 27.81L23.4384 30.6203L29.1755 24.8811L26.3674 22.0729L20.6281 27.81Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30573_15491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.f334433ea69e2e530e86b017b749dd3a.svg";
export { ForwardRef as ReactComponent };